import { httpClient } from "../../../core/api/http/httpClient";
import { LoginPayload, LoginResponse, AuthMeResponse } from "../model/auth.types";

const baseRoute = "/auth";

export const authApi = {
  login: (payload: LoginPayload) =>
    httpClient.post<LoginResponse, LoginPayload>(`${baseRoute}/login`, payload),
  logout: () => httpClient.post<{ message: string }>(`${baseRoute}/logout`),
  getMe: () => httpClient.get<AuthMeResponse>(`${baseRoute}/me`),
};
